export default __webpack_public_path__ + "8e7bdaf364c80f914da838e40e15d83e.png";